module.exports = __webpack_public_path__ + "img/clipboards-secondary.bf99d92b.svg";